import React from 'react';

import { Alert, Grid, Section } from '@gogame/components';
import { SidePageV2, FormField, withForm } from '@gogame/form';

import {
  loadOwners,
  loadApplications,
  loadNetworks,
  loadPlatforms,
} from 'scenes/CustomAudiences/Audiences/sources/fields';
import PartnerAudiencesFieldset from 'scenes/CustomAudiences/PartnerAudiences/components/PartnerAudienceForm/PartnerAudiencesFieldset';

import { useUploadAttachments } from 'scenes/CustomAudiences/Audiences/data/mutations';
import {
  NAME,
  OWNER,
  APPLICATIONS,
  NETWORKS,
  PLATFORMS,
  ATTACH_FILE,
  PARTNER_AUDIENCES,
  DEPENDENCIES,
} from './constants';
import { FileBasedAudienceFormValidationSchema } from './schemas';

const getFileKey = (key) => key;

const FileBasedAudienceForm = withForm({
  validationSchema: FileBasedAudienceFormValidationSchema,
  enableReinitialize: true,
})(({
  title,
  subTitle,
  loading,
  onClose,
  onExited,
  open,
  entityId,
  isEdit,
}) => {
  const uploadAttachments = useUploadAttachments();

  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      open={open}
      loading={loading}
      size={'lg'}
    >
      <SidePageV2.Title title={title} subTitle={subTitle} entityId={entityId} />
      <SidePageV2.NewBody wrapper={true} dense={true}>
        <SidePageV2.NewContent withSidebar={false}>
          <Section title={'General'}>
            <Grid container spacing={3}>
              <Grid item xs={8}>
                <FormField.TextField
                  label={'Name'}
                  required={true}
                  padding={0}
                  name={NAME}
                />
              </Grid>
              <Grid item xs={4}>
                <FormField.Select
                  label={'Owner'}
                  padding={0}
                  name={OWNER}
                  source={loadOwners}
                />
              </Grid>
            </Grid>
          </Section>
          {!isEdit ? (
            <React.Fragment>
              <Section title={'Population'}>
                <Grid container spacing={3}>
                  <Grid item xs={4}>
                    <FormField.MultiSelect
                      name={APPLICATIONS}
                      label={'Applications'}
                      source={loadApplications}
                      depends={DEPENDENCIES[APPLICATIONS]}
                      required={true}
                      padding={0}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <FormField.MultiSelect
                      name={NETWORKS}
                      label={'Networks'}
                      source={loadNetworks}
                      required={true}
                      padding={0}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <FormField.MultiSelect
                      name={PLATFORMS}
                      label={'Platforms'}
                      source={loadPlatforms}
                      depends={DEPENDENCIES[PLATFORMS]}
                      required={true}
                      padding={0}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormField.AttachmentField
                      name={ATTACH_FILE}
                      label={'Attach file'}
                      tooltip={'Only .csv files are allowed'}
                      accept={'.csv'}
                      onUpload={uploadAttachments}
                      getFileKey={getFileKey}
                      variant={'outlined'}
                      padding={0}
                    />
                  </Grid>
                </Grid>
              </Section>
              <Alert severity={'info'}>
                Ensure that the CSV file has only one column, and designate
                "RegActionId" as the header
              </Alert>
              <PartnerAudiencesFieldset
                name={PARTNER_AUDIENCES}
                depends={[NETWORKS, PLATFORMS]}
                editable={true}
              />
            </React.Fragment>
          ) : null}
        </SidePageV2.NewContent>
      </SidePageV2.NewBody>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton />
      </SidePageV2.Actions>
    </SidePageV2>
  );
});

export default FileBasedAudienceForm;
